import './ccf-wem-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfWemIconProps extends SvgIconProps {}

/**
 * CcfWemIcon used to disply WEM icon in the navigation panel
 * @param props - CcfWemIconProps
 * @example -- <CcfWemIcon />
 */
export function CcfWemIcon(props: CcfWemIconProps) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 -2.5 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_10174_4424)">
        <path
          d="M9.19314 8.94888C9.19314 7.79598 10.1277 6.86138 11.2806 6.86138C12.4335 6.86138 13.3681 7.79598 13.3681 8.94888C13.3681 10.1018 12.4335 11.0364 11.2806 11.0364C10.1277 11.0364 9.19314 10.1018 9.19314 8.94888ZM11.2806 5.41138C9.32694 5.41138 7.74317 6.99517 7.74317 8.94888C7.74317 10.9026 9.32694 12.4864 11.2806 12.4864C13.2343 12.4864 14.8181 10.9026 14.8181 8.94888C14.8181 6.99517 13.2343 5.41138 11.2806 5.41138ZM6.18318 17.2588C7.51974 15.8412 9.31634 14.9864 11.2806 14.9864C13.2449 14.9864 15.0415 15.8412 16.3781 17.2588C16.6528 17.5501 17.1116 17.5636 17.403 17.2889C17.6943 17.0142 17.7078 16.5554 17.4331 16.2641C15.85 14.5849 13.6825 13.5364 11.2806 13.5364C8.87875 13.5364 6.71132 14.5849 5.12816 16.2641C4.85348 16.5554 4.86698 17.0142 5.15832 17.2889C5.44966 17.5636 5.9085 17.5501 6.18318 17.2588Z"
          fill="#333333"
          stroke="#333333"
          stroke-width="0.3"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.1701 0.890996C11.5513 0.533731 10.7889 0.53373 10.1701 0.890996L1.77783 5.7363C1.15903 6.09356 0.777832 6.75382 0.777832 7.46835V17.1589C0.777832 17.8735 1.15903 18.5337 1.77783 18.891L10.1701 23.7363C10.7889 24.0936 11.5513 24.0936 12.1701 23.7363L20.5624 18.891C21.1812 18.5337 21.5624 17.8735 21.5624 17.1589V7.46835C21.5624 6.75382 21.1812 6.09356 20.5624 5.7363L12.1701 0.890996ZM11.6796 2.7548C11.364 2.57259 10.9752 2.5726 10.6596 2.7548L3.1462 7.09268C2.83061 7.27489 2.6362 7.61162 2.6362 7.97603V16.6518C2.6362 17.0162 2.83061 17.3529 3.1462 17.5351L10.6596 21.873C10.9752 22.0552 11.364 22.0552 11.6796 21.873L19.1931 17.5351C19.5086 17.3529 19.7031 17.0162 19.7031 16.6518V7.97603C19.7031 7.61162 19.5086 7.27489 19.1931 7.09268L11.6796 2.7548Z"
          fill="#333333"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_10174_4424">
          <rect width="22" height="24" fill="white"></rect>
        </clipPath>
      </defs>
    </svg>
  );
}

export default CcfWemIcon;
